import styled from "styled-components";

export const Form = styled.form`
  display: flex;
  flex-direction: column;
`;

export const FormRow = styled.div`
  display: flex;
  align-items: center;
`;

export const PartContainer = styled.div`
  position: relative;
`;

export const PartPlaceholder = styled.div`
  position: absolute;
  top: 1.5rem;
  bottom: 0%;
  left: 0%;
  right: 0%;
  z-index: -1;
`;
